// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TYPOGRAPHY */

/* DISPLAYS */
.display-1 {
  font-family: var(--font-display-1);
  font-weight: 700;
  font-size: var(--font-size-display-1);
  line-height: var(--line-height-display-1);
  letter-spacing: var(--letter-spacing-normal);
}

.display-2 {
  font-family: var(--font-headline-1);
  font-weight: 500;
  font-size: var(--font-size-display-2);
  line-height: var(--line-height-display-2);
  letter-spacing: var(--letter-spacing-normal);
}

@media (max-width: 768px) {
  .display-2 {
    font-size: var(--font-size-s3-subtitle);
    line-height: var(--line-height-s3-subtitle);
  }
}

/* HEADLINES */
h1 {
  font-family: var(--font-headline-1);
  font-weight: 600;
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
  letter-spacing: var(--letter-spacing-headline);
}
h2 {
  font-family: var(--font-headline-2);
  font-weight: 500;
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
  letter-spacing: var(--letter-spacing-normal);
}
h3 {
  font-family: var(--font-headline-3);
  font-weight: 500;
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
  letter-spacing: var(--letter-spacing-normal);
}
h4 {
  font-family: var(--font-headline-1);
  font-weight: 600;
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
  letter-spacing: var(--letter-spacing-normal);
}
h5 {
  font-family: var(--font-headline-3);
  font-weight: 500;
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
  letter-spacing: var(--letter-spacing-normal);
}
.h2-mobile {
  font-family: var(--font-headline-2);
  font-weight: 500;
  font-size: var(--font-size-h2-mobile);
  line-height: var(--line-height-h3);
  letter-spacing: var(--letter-spacing-normal);
}

@media (max-width: 768px) {
  h2 {
    font-size: var(--font-size-h2-mobile);
    line-height: var(--line-height-h3);
  }

  h3 {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h2);
  }

  h4 {
    font-family: var(--font-paragraph-3);
    font-weight: 500;
    font-size: var(--font-size-p3-paragraph);
    line-height: var(--line-height-p3-paragraph);
    letter-spacing: var(--letter-spacing-paragraph);
  }
}

/* SUBTITLE */
.s1-subtitle {
  font-family: var(--font-headline-2);
  font-weight: 500;
  font-size: var(--font-size-s1-subtitle);
  line-height: var(--line-height-s1-subtitle);
  letter-spacing: var(--letter-spacing-normal);
}
.s2-subtitle {
  font-family: var(--font-headline-1);
  font-weight: 600;
  font-size: var(--font-size-s2-subtitle);
  line-height: var(--line-height-s2-subtitle);
  letter-spacing: var(--letter-spacing-s2-subtitle);
  vertical-align: bottom;
}
.s3-subtitle {
  font-family: var(--font-headline-2);
  font-weight: 500;
  font-size: var(--font-size-s3-subtitle);
  line-height: var(--line-height-s3-subtitle);
  letter-spacing: var(--letter-spacing-normal);
}

@media (max-width: 768px) {
  .s1-subtitle {
    font-size: var(--font-size-s3-subtitle);
    line-height: var(--line-height-s3-subtitle);
  }

  .s2-subtitle {
    font-family: var(--font-headline-2);
    font-weight: 500;
    font-size: var(--font-size-s3-subtitle);
    line-height: var(--line-height-s3-subtitle);
    letter-spacing: var(--letter-spacing-normal);
  }
}

@media (max-width: 520px) {
  .s1-subtitle {
    font-size: var(--font-size-p1-paragraph);
  }
}

/* PARAGRAPH */
.p1-paragraph {
  font-family: var(--font-paragraph-1);
  font-weight: 400;
  font-size: var(--font-size-p1-paragraph);
  line-height: var(--line-height-p1-paragraph);
  letter-spacing: var(--letter-spacing-paragraph);
}
.p2-paragraph {
  font-family: var(--font-paragraph-2);
  font-weight: 600;
  font-size: var(--font-size-p2-paragraph);
  line-height: var(--line-height-p2-paragraph);
  letter-spacing: var(--letter-spacing-paragraph);
}
.p3-paragraph {
  font-family: var(--font-paragraph-3);
  font-weight: 500;
  font-size: var(--font-size-p3-paragraph);
  line-height: var(--line-height-p3-paragraph);
  letter-spacing: var(--letter-spacing-paragraph);
}
.p4-paragraph {
  font-family: var(--font-paragraph-4);
  font-weight: 400;
  font-size: var(--font-size-p4-paragraph);
  line-height: var(--line-height-p4-paragraph);
  letter-spacing: var(--letter-spacing-paragraph);
}

@media (max-width: 768px) {
  .p1-paragraph {
    font-size: var(--font-size-p3-paragraph);
    line-height: var(--line-height-p3-paragraph);
  }

  .p2-paragraph {
    font-size: var(--font-size-p3-paragraph);
    line-height: var(--line-height-p3-paragraph);
  }
}

/* DISCLAIMER */
.d1-disclaimer {
  font-family: var(--font-paragraph-3);
  font-weight: 500;
  font-size: var(--font-size-d1-disclaimer);
  line-height: var(--line-height-d1-disclaimer);
  letter-spacing: var(--letter-spacing-disclaimer);
  vertical-align: bottom;
}
.d2-disclaimer {
  font-family: var(--font-paragraph-3);
  font-weight: 500;
  font-size: var(--font-size-d2-disclaimer);
  line-height: var(--line-height-d2-disclaimer);
  letter-spacing: var(--letter-spacing-disclaimer);
  vertical-align: bottom;
}

/* CAPTION */
.c4-caption {
  font-family: var(--font-paragraph-2);
  font-weight: 600;
  font-size: var(--font-size-d1-disclaimer);
  line-height: var(--line-height-p3-paragraph);
  letter-spacing: var(--letter-spacing-normal);
}

.highlight-text {
  color: var(--color-primary-red);
}

.highlight-dark-text {
  color: var(--color-contrast-dark-red);
}
`, "",{"version":3,"sources":["webpack://./src/styles/global/typestyle.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf,aAAa;AACb;EACE,kCAAkC;EAClC,gBAAgB;EAChB,qCAAqC;EACrC,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,qCAAqC;EACrC,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE;IACE,uCAAuC;IACvC,2CAA2C;EAC7C;AACF;;AAEA,cAAc;AACd;EACE,mCAAmC;EACnC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,8CAA8C;AAChD;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,4CAA4C;AAC9C;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,4CAA4C;AAC9C;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,4CAA4C;AAC9C;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,4CAA4C;AAC9C;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,qCAAqC;EACrC,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE;IACE,qCAAqC;IACrC,kCAAkC;EACpC;;EAEA;IACE,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA;IACE,oCAAoC;IACpC,gBAAgB;IAChB,wCAAwC;IACxC,4CAA4C;IAC5C,+CAA+C;EACjD;AACF;;AAEA,aAAa;AACb;EACE,mCAAmC;EACnC,gBAAgB;EAChB,uCAAuC;EACvC,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,uCAAuC;EACvC,2CAA2C;EAC3C,iDAAiD;EACjD,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,uCAAuC;EACvC,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE;IACE,uCAAuC;IACvC,2CAA2C;EAC7C;;EAEA;IACE,mCAAmC;IACnC,gBAAgB;IAChB,uCAAuC;IACvC,2CAA2C;IAC3C,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA,cAAc;AACd;EACE,oCAAoC;EACpC,gBAAgB;EAChB,wCAAwC;EACxC,4CAA4C;EAC5C,+CAA+C;AACjD;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,wCAAwC;EACxC,4CAA4C;EAC5C,+CAA+C;AACjD;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,wCAAwC;EACxC,4CAA4C;EAC5C,+CAA+C;AACjD;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,wCAAwC;EACxC,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE;IACE,wCAAwC;IACxC,4CAA4C;EAC9C;;EAEA;IACE,wCAAwC;IACxC,4CAA4C;EAC9C;AACF;;AAEA,eAAe;AACf;EACE,oCAAoC;EACpC,gBAAgB;EAChB,yCAAyC;EACzC,6CAA6C;EAC7C,gDAAgD;EAChD,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,yCAAyC;EACzC,6CAA6C;EAC7C,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,oCAAoC;EACpC,gBAAgB;EAChB,yCAAyC;EACzC,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":["/* TYPOGRAPHY */\n\n/* DISPLAYS */\n.display-1 {\n  font-family: var(--font-display-1);\n  font-weight: 700;\n  font-size: var(--font-size-display-1);\n  line-height: var(--line-height-display-1);\n  letter-spacing: var(--letter-spacing-normal);\n}\n\n.display-2 {\n  font-family: var(--font-headline-1);\n  font-weight: 500;\n  font-size: var(--font-size-display-2);\n  line-height: var(--line-height-display-2);\n  letter-spacing: var(--letter-spacing-normal);\n}\n\n@media (max-width: 768px) {\n  .display-2 {\n    font-size: var(--font-size-s3-subtitle);\n    line-height: var(--line-height-s3-subtitle);\n  }\n}\n\n/* HEADLINES */\nh1 {\n  font-family: var(--font-headline-1);\n  font-weight: 600;\n  font-size: var(--font-size-h1);\n  line-height: var(--line-height-h1);\n  letter-spacing: var(--letter-spacing-headline);\n}\nh2 {\n  font-family: var(--font-headline-2);\n  font-weight: 500;\n  font-size: var(--font-size-h2);\n  line-height: var(--line-height-h2);\n  letter-spacing: var(--letter-spacing-normal);\n}\nh3 {\n  font-family: var(--font-headline-3);\n  font-weight: 500;\n  font-size: var(--font-size-h3);\n  line-height: var(--line-height-h3);\n  letter-spacing: var(--letter-spacing-normal);\n}\nh4 {\n  font-family: var(--font-headline-1);\n  font-weight: 600;\n  font-size: var(--font-size-h4);\n  line-height: var(--line-height-h4);\n  letter-spacing: var(--letter-spacing-normal);\n}\nh5 {\n  font-family: var(--font-headline-3);\n  font-weight: 500;\n  font-size: var(--font-size-h5);\n  line-height: var(--line-height-h5);\n  letter-spacing: var(--letter-spacing-normal);\n}\n.h2-mobile {\n  font-family: var(--font-headline-2);\n  font-weight: 500;\n  font-size: var(--font-size-h2-mobile);\n  line-height: var(--line-height-h3);\n  letter-spacing: var(--letter-spacing-normal);\n}\n\n@media (max-width: 768px) {\n  h2 {\n    font-size: var(--font-size-h2-mobile);\n    line-height: var(--line-height-h3);\n  }\n\n  h3 {\n    font-size: var(--font-size-h5);\n    line-height: var(--line-height-h2);\n  }\n\n  h4 {\n    font-family: var(--font-paragraph-3);\n    font-weight: 500;\n    font-size: var(--font-size-p3-paragraph);\n    line-height: var(--line-height-p3-paragraph);\n    letter-spacing: var(--letter-spacing-paragraph);\n  }\n}\n\n/* SUBTITLE */\n.s1-subtitle {\n  font-family: var(--font-headline-2);\n  font-weight: 500;\n  font-size: var(--font-size-s1-subtitle);\n  line-height: var(--line-height-s1-subtitle);\n  letter-spacing: var(--letter-spacing-normal);\n}\n.s2-subtitle {\n  font-family: var(--font-headline-1);\n  font-weight: 600;\n  font-size: var(--font-size-s2-subtitle);\n  line-height: var(--line-height-s2-subtitle);\n  letter-spacing: var(--letter-spacing-s2-subtitle);\n  vertical-align: bottom;\n}\n.s3-subtitle {\n  font-family: var(--font-headline-2);\n  font-weight: 500;\n  font-size: var(--font-size-s3-subtitle);\n  line-height: var(--line-height-s3-subtitle);\n  letter-spacing: var(--letter-spacing-normal);\n}\n\n@media (max-width: 768px) {\n  .s1-subtitle {\n    font-size: var(--font-size-s3-subtitle);\n    line-height: var(--line-height-s3-subtitle);\n  }\n\n  .s2-subtitle {\n    font-family: var(--font-headline-2);\n    font-weight: 500;\n    font-size: var(--font-size-s3-subtitle);\n    line-height: var(--line-height-s3-subtitle);\n    letter-spacing: var(--letter-spacing-normal);\n  }\n}\n\n@media (max-width: 520px) {\n  .s1-subtitle {\n    font-size: var(--font-size-p1-paragraph);\n  }\n}\n\n/* PARAGRAPH */\n.p1-paragraph {\n  font-family: var(--font-paragraph-1);\n  font-weight: 400;\n  font-size: var(--font-size-p1-paragraph);\n  line-height: var(--line-height-p1-paragraph);\n  letter-spacing: var(--letter-spacing-paragraph);\n}\n.p2-paragraph {\n  font-family: var(--font-paragraph-2);\n  font-weight: 600;\n  font-size: var(--font-size-p2-paragraph);\n  line-height: var(--line-height-p2-paragraph);\n  letter-spacing: var(--letter-spacing-paragraph);\n}\n.p3-paragraph {\n  font-family: var(--font-paragraph-3);\n  font-weight: 500;\n  font-size: var(--font-size-p3-paragraph);\n  line-height: var(--line-height-p3-paragraph);\n  letter-spacing: var(--letter-spacing-paragraph);\n}\n.p4-paragraph {\n  font-family: var(--font-paragraph-4);\n  font-weight: 400;\n  font-size: var(--font-size-p4-paragraph);\n  line-height: var(--line-height-p4-paragraph);\n  letter-spacing: var(--letter-spacing-paragraph);\n}\n\n@media (max-width: 768px) {\n  .p1-paragraph {\n    font-size: var(--font-size-p3-paragraph);\n    line-height: var(--line-height-p3-paragraph);\n  }\n\n  .p2-paragraph {\n    font-size: var(--font-size-p3-paragraph);\n    line-height: var(--line-height-p3-paragraph);\n  }\n}\n\n/* DISCLAIMER */\n.d1-disclaimer {\n  font-family: var(--font-paragraph-3);\n  font-weight: 500;\n  font-size: var(--font-size-d1-disclaimer);\n  line-height: var(--line-height-d1-disclaimer);\n  letter-spacing: var(--letter-spacing-disclaimer);\n  vertical-align: bottom;\n}\n.d2-disclaimer {\n  font-family: var(--font-paragraph-3);\n  font-weight: 500;\n  font-size: var(--font-size-d2-disclaimer);\n  line-height: var(--line-height-d2-disclaimer);\n  letter-spacing: var(--letter-spacing-disclaimer);\n  vertical-align: bottom;\n}\n\n/* CAPTION */\n.c4-caption {\n  font-family: var(--font-paragraph-2);\n  font-weight: 600;\n  font-size: var(--font-size-d1-disclaimer);\n  line-height: var(--line-height-p3-paragraph);\n  letter-spacing: var(--letter-spacing-normal);\n}\n\n.highlight-text {\n  color: var(--color-primary-red);\n}\n\n.highlight-dark-text {\n  color: var(--color-contrast-dark-red);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
